import { FuelButton, FuelSign, FuelTypography, FuelInteractiveIcon } from '@frete.com/fuel-react';
import { FuelFlex, FuelModal } from '@frete.com/fuel-station-react';
import React, { FC } from 'react';
import InsuranceCompaniesList from 'externals/InsuranceCompaniesList';
import TextLink from 'components/ui/TextLink';
import { DS_TOKENS } from 'constants/styled.contants';
import { useTruckerProps } from 'hooks/useTruckerProps';

interface ICompaniesListModal {
  handleCloseModal: () => void;
  isModalOpen: boolean;
}

const CompaniesListModal: FC<ICompaniesListModal> = ({ isModalOpen, handleCloseModal }) => {
  const { GUEP_URL, SKYMARK_URL } = process.env;
  const { portalName } = useTruckerProps();

  return (
    <FuelModal
      isOpen={isModalOpen}
      portalName={portalName}
      onClose={handleCloseModal}
      removePortalOnDestroy={false}
      fixedMaxWidth
      data-testid="companies-list-modal"
    >
      <FuelFlex defaultProps={{ justifyContent: 'flex-end', gap: 'km2' }}>
        <FuelInteractiveIcon
          onClick={handleCloseModal}
          size="small"
          icon="close"
          data-testid="close-interactive-icon"
        />
      </FuelFlex>
      <FuelFlex defaultProps={{ customMargin: `${DS_TOKENS.spacing.km5} 0 ${DS_TOKENS.spacing.km5} 0` }}>
        <FuelSign icon="one-check" size="medium" iconStyle="filled" />
      </FuelFlex>
      <FuelTypography color="neutral-strong" size="body-lg" weight="bold" spacingBottom={16}>
        Aceita pelas seguradoras
      </FuelTypography>
      <FuelTypography color="neutral-default" size="body-md" weight="regular" spacingBottom={20}>
        Validações feitas pela{' '}
        <TextLink label="Skymark" link={SKYMARK_URL} externalRoute fontWeight={DS_TOKENS.font.weight.medium} /> e{' '}
        <TextLink label="GUEP" link={GUEP_URL} externalRoute fontWeight={DS_TOKENS.font.weight.medium} />, nossas GRs
        parceiras. Homologadas e aceitas por todas as seguradoras, veja algumas:
      </FuelTypography>
      <InsuranceCompaniesList />

      <FuelFlex
        defaultProps={{
          justifyContent: 'flex-end',
          gap: 'km2',
          customMargin: `${DS_TOKENS.spacing.km6} 0 0 0`,
        }}
      >
        <FuelButton variant="primary" size="large" onClick={handleCloseModal}>
          Entendi
        </FuelButton>
      </FuelFlex>
    </FuelModal>
  );
};

export default CompaniesListModal;
